import React from 'react'
import { IS_EQT_FOUNDATION } from '../../utilities/site'

export interface DropdownItemProps {
  id: string
  isPlaceholder?: boolean
  focused?: boolean
  index: number
  label: string
  onClick: (index: number) => void
  selected: boolean
}

export const DropdownItem = ({
  id,
  index,
  isPlaceholder = false,
  focused = false,
  label,
  onClick: onClickCallback,
  selected,
}: DropdownItemProps): JSX.Element => {
  const onClick = () => {
    onClickCallback(index)
  }

  const focusColor = IS_EQT_FOUNDATION ? 'bg-shade-lightest-warm' : 'bg-neutral-lighter'
  const placeholderStyle = IS_EQT_FOUNDATION
    ? 'border-b border-shade-lightest-warm'
    : 'border-b border-neutral-lighter'

  // Note: needs some additional padding to the right due to Firefox overflowing text next to the scrollbar.
  // This also prevents the use of ellipsis when clipping the text.

  return (
    <li
      id={id}
      role="option"
      aria-selected={selected}
      className={`py-2 first:pt-10 last:pb-10 px-10 group cursor-pointer hover:text-primary ${
        selected ? 'text-primary' : ''
      } ${isPlaceholder ? placeholderStyle : ''}`}
      onClick={onClick}
    >
      <div
        className={`py-4 pl-4 pr-20 overflow-hidden rounded-4 ${
          focused ? focusColor : ''
        }`}
      >
        <span
          className={`relative inline-flex justify-center items-center w-20 h-20 mr-10 rounded-full border overflow-hidden ${
            selected ? 'border-primary' : 'border-neutral-light'
          } group-hover:border-primary`}
        >
          <span
            className={`rounded-full w-10 h-10 ${
              selected ? 'bg-primary' : 'bg-neutral-light'
            }`}
          ></span>
        </span>
        <span className="select-none">{label}</span>
      </div>
    </li>
  )
}
